import { render, staticRenderFns } from "./ContainerIndex.vue?vue&type=template&id=87887f58&"
import script from "./ContainerIndex.vue?vue&type=script&lang=js&"
export * from "./ContainerIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports